import { useSession } from 'src/apps/invest/common/hooks/useSession';
import React, { useEffect } from 'react';
import { ROUTES } from 'src/apps/invest/config';
import { InvestorProfilePage } from '../views/InvestorProfilePage';
import { usePermissions } from 'src/apps/invest/common/hooks/usePermissions';
import { Permission } from '@common/permissions';
import { PageNotFound } from 'src/apps/invest/common/PageNotFound';

const sessionRedirect = ROUTES.profile;
const permissions: Permission[] = ['ACCREDITED_INVESTOR', 'UNACCREDITED_INVESTOR'];

type InvestorProfileControllerProps = {
  page?: 'main';
};

export const InvestorProfileController: React.FC<InvestorProfileControllerProps> = ({ page = 'main' }) => {
  const { checkAuthenticated } = useSession();
  const { checkPermissions } = usePermissions();

  async function init() {
    if (!(await checkAuthenticated(sessionRedirect))) return;
    if (!(await checkPermissions(permissions))) return;
  }

  useEffect(() => {
    init();
  }, []);

  switch (page) {
    case 'main':
      return <InvestorProfilePage />;
    default:
      return <PageNotFound />;
  }
};
